import { Injectable } from '@angular/core';
import { AdminService } from './custom/admin.service';

@Injectable({
  providedIn: 'root'
})
export class HoverService {

  activeComponent;

  setActive(component) {
    this.clearActive();
    try {
      component.isActive = true;
    }
    catch (err) {
      console.error('isActive variable doesn\'t exist in component class');
    }
    this.activeComponent = component;
  }

  clearActive() {
    try {
      if (this.activeComponent)
        this.activeComponent.isActive = false;
    } catch (err) {
      console.error('isActive variable doesn\'t exist in component class');
    }
    this.activeComponent = null;
  }

  elementsStack = [];

  constructor(private adminService : AdminService) { }

  onMouseEnter(element, ) {
    if (!this.adminService.liveEdit)
      return;

    // let elem = document.createElement('div');
    // elem.classList.add('hover-overlay');
    // element.insertAdjacentElement('afterend', elem);

    if (this.elementsStack.length) {
      this.elementsStack[this.elementsStack.length - 1].classList.remove('hover');
    }

    element.classList.add('hover');
    this.elementsStack.push(element);

  }

  onMouseLeave(element, )  {
    if (!this.adminService.liveEdit)
      return;

    this.elementsStack.pop();
    element.classList.remove('hover');

    if (this.elementsStack.length) {
      this.elementsStack[this.elementsStack.length - 1].classList.add('hover');
    }
  }

}
